import React from 'react';
import PropTypes from 'prop-types';
import { NavItem, NavLink } from 'seduo-ui';
import { Link } from 'react-router';
import { path } from '../basename';
const UINavLink = ({ name, to }) => (<NavItem>
        <NavLink tag={Link} to={path(to)} activeClassName="active">
            {name}
        </NavLink>
    </NavItem>);
UINavLink.propTypes = {
    name: PropTypes.string.isRequired,
    to: PropTypes.string.isRequired,
};
export default UINavLink;
